import { useEffect } from 'react'

import { FormField, Link } from '@domain-group/suit-theme'

import type { UseOrderApprovalPayload } from '@modals/ApproveOrderModal/hooks/useOrderApproval'

type DeliveryAddressProps = {
  orderApprovalPayload: UseOrderApprovalPayload,
}

const DeliveryAddress = (props: DeliveryAddressProps) => {
  const {
    orderApprovalPayload: {
      agency: {
        id: agencyId,
      },
      callbacks: {
        selectAddressId,
        setEntityState,
        setState,
        updateOrder,
      },
      entityState: {
        id: entityStateId,
        shipping_address,
      },
      filteredAddresses,
      loadedAddresses,
      order: { id },
      selectedAddressId,
    },
  } = props

  const defaultShippingAddress = filteredAddresses.find(({ is_default }) => !!is_default) || {}

  // Set Default Shipping Address if exists
  useEffect(() => {
    if (loadedAddresses && entityStateId){
      // @ts-expect-error TS2339
      selectAddressId(defaultShippingAddress.id || 'physical_address')
    }
  // @ts-expect-error TS2339
  }, [defaultShippingAddress.id, loadedAddresses, entityStateId])

  return (
    <FormField direction="column" label="Delivery Address" marginTop="large">
      <select
        onChange={e => selectAddressId(e.target.value)}
        value={selectedAddressId || ''}
        style={{ marginBottom: 8 }}
      >
        <option value="">Select from Saved Addresses...</option>
        {/*
         // @ts-expect-error TS2339 */}
        <option value="physical_address">Agency Physical Address{!defaultShippingAddress.id && ' (Default)'}</option>
        {filteredAddresses.map(address => (
          <option key={address.id} value={address.id}>
            {address.title}
            {address.is_default && ' (Default)'}
          </option>
        ))}
      </select>

      <textarea
        onBlur={(e) => {
          setState({ selectedAddressId: undefined })
          updateOrder({ id, shipping_address: e.target.value })
        }}
        onChange={e => setEntityState({ shipping_address: e.target.value })}
        value={shipping_address}
        style={{ height: 86, resize: 'vertical' }}
      />

      <Link
        textProps={{ display: ['none', 'block'], fontSize: 'xsmall', marginTop: 'medium' }}
        href={`#/agencies/${agencyId}/manage/details`}
      >
        Edit Default Address
      </Link>
    </FormField>
  )
}

export default DeliveryAddress
